// Colunas do grid.
export const Columns = [
	{
		headerName: 'name',
		field: 'fullName',
		filter: true
	},
	{
		headerName: 'email',
		field: 'email',
		filter: true,
		width: '350'
	},
	{
		headerName: 'blocked',
		field: 'blocked',
		width: '120'
	},
	{
		headerName: 'admin',
		field: 'admin',
		width: '100'
	},
	{
		headerName: 'group',
		field: 'group.name',
		width: '150'
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans'
	}
]